import React from 'react'

import {
    CalendarBlank,
    Check,
    MagnifyingGlass,
    Plus,
    Gear,
    X,
    Info,
    DotsThree,
    DotsThreeVertical,
    ArrowUpRight,
    WarningCircle,
    CheckSquare,
    ArrowSquareIn,
    Funnel,
    Eye,
    Export,
    DownloadSimple,
    SortAscending,
    SortDescending,
    DotsThreeOutline,
    Copy,
    EyeClosed,
    XCircle,
    CaretUp,
    CaretDown,
    Lock,
    LockOpen,
    PencilSimple,
    ArrowsDownUp,
    DotsSixVertical,
} from 'phosphor-react'

type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone'

export interface IconProps {
    color?: string
    size?: string | number
    weight?: IconWeight
}

const CalendarBlankIcon: React.FC<IconProps> = ({ ...props }) => <CalendarBlank {...props} />
const CheckIcon: React.FC<IconProps> = ({ ...props }) => <Check {...props} />
const SearchIcon: React.FC<IconProps> = ({ ...props }) => <MagnifyingGlass {...props} />
const PlusIcon: React.FC<IconProps> = ({ ...props }) => <Plus {...props} />
const GearIcon: React.FC<IconProps> = ({ ...props }) => <Gear {...props} />
const XIcon: React.FC<IconProps> = ({ ...props }) => <X {...props} />
const InfoIcon: React.FC<IconProps> = ({ ...props }) => <Info {...props} />
const DotsThreeIcon: React.FC<IconProps> = ({ ...props }) => <DotsThree {...props} />
const DotsThreeVerticalIcon: React.FC<IconProps> = ({ ...props }) => <DotsThreeVertical {...props} />
const ArrowUpRightIcon: React.FC<IconProps> = ({ ...props }) => <ArrowUpRight {...props} />
const WarningCircleIcon: React.FC<IconProps> = ({ ...props }) => <WarningCircle {...props} />
const CheckSquareIcon: React.FC<IconProps> = ({ ...props }) => <CheckSquare {...props} />
const ArrowSquareInIcon: React.FC<IconProps> = ({ ...props }) => <ArrowSquareIn {...props} />
const FunnelIcon: React.FC<IconProps> = ({ ...props }) => <Funnel {...props} />
const EyeIcon: React.FC<IconProps> = ({ ...props }) => <Eye {...props} />
const ExportIcon: React.FC<IconProps> = ({ ...props }) => <Export {...props} />
const DownloadSimpleIcon: React.FC<IconProps> = ({ ...props }) => <DownloadSimple {...props} />
const SortAscendingIcon: React.FC<IconProps> = ({ ...props }) => <SortAscending {...props} />
const SortDescendingIcon: React.FC<IconProps> = ({ ...props }) => <SortDescending {...props} />
const DotsThreeOutlineIcon: React.FC<IconProps> = ({ ...props }) => <DotsThreeOutline {...props} />
const CopyIcon: React.FC<IconProps> = ({ ...props }) => <Copy {...props} />
const EyeClosedIcon: React.FC<IconProps> = ({ ...props }) => <EyeClosed {...props} />
const XCircleIcon: React.FC<IconProps> = ({ ...props }) => <XCircle {...props} />
const CaretUpIcon: React.FC<IconProps> = ({ ...props }) => <CaretUp {...props} />
const CaretDownIcon: React.FC<IconProps> = ({ ...props }) => <CaretDown {...props} />
const LockIcon: React.FC<IconProps> = ({ ...props }) => <Lock {...props} />
const LockOpenIcon: React.FC<IconProps> = ({ ...props }) => <LockOpen {...props} />
const PencilSimpleIcon: React.FC<IconProps> = ({ ...props }) => <PencilSimple {...props} />
const ArrowsDownUpIcon: React.FC<IconProps> = ({ ...props }) => <ArrowsDownUp {...props} />
const DotsSixVerticalIcon: React.FC<IconProps> = ({ ...props }) => <DotsSixVertical {...props} />

/**
 * @deprecated Please use particles/Icon
 */
export default {
    CalendarBlankIcon,
    CheckIcon,
    SearchIcon,
    PlusIcon,
    GearIcon,
    XIcon,
    InfoIcon,
    DotsThreeIcon,
    DotsThreeVerticalIcon,
    ArrowUpRightIcon,
    WarningCircleIcon,
    CheckSquareIcon,
    ArrowSquareInIcon,
    FunnelIcon,
    EyeIcon,
    ExportIcon,
    DownloadSimpleIcon,
    SortAscendingIcon,
    SortDescendingIcon,
    DotsThreeOutlineIcon,
    CopyIcon,
    EyeClosedIcon,
    XCircleIcon,
    CaretUpIcon,
    CaretDownIcon,
    LockIcon,
    LockOpenIcon,
    PencilSimpleIcon,
    ArrowsDownUpIcon,
    DotsSixVerticalIcon,
}
